import React from "react"
import { Box, Container, useTheme } from "@mui/material"
import { AppNavigation as DefaultAppNavigation } from "containers/AppNavigation"

export const PageLayout = ({
  children,
  header = null,
  AppNavigation = DefaultAppNavigation,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, container, headerWrapper, navigationContainer } = styleOverrides

  return (
    <Box sx={root} {...props} data-name="PageLayout">
      <Box sx={headerWrapper}>{header}</Box>
      <Container maxWidth="md" sx={container}>
        {children}
      </Container>
      <Box sx={navigationContainer}>
        <AppNavigation />
      </Box>
    </Box>
  )
}
